// Currency Exchanges Mutations

export const updateCurrencyExchangesList = (state, payload) => {
  state.currencyExchangesList = payload
}

export const setCurrencyExchangeInfo = (state, payload) => {
  state.currencyExchangeInfo = payload
}
